// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-field{border-bottom:1px solid var(--card-border-color);padding:2px 5px}
`, "",{"version":3,"sources":["webpack://./src/ReadAndWrite/components/InfoField/styles.scss"],"names":[],"mappings":"AAAA,YACE,gDAAiD,CACjD,eAAgB","sourcesContent":[".info-field {\n  border-bottom: 1px solid var(--card-border-color);\n  padding: 2px 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
